// Packages
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  disagree: {
    fontSize: 14,
    marginRight: 10,
  },
}));
